module.exports = __webpack_public_path__ + "img/import-icon-nobg.fb1d3363.svg";